import React, { useCallback, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as Yup from "yup"
import { useFormik } from "formik"
import { Card, CardBody, Col, Row } from "reactstrap"
import { FormInput } from "components/Extra/FormInput"
import { Products } from "pages/admin/Products"
import { useTranslation } from "react-i18next"
import { TopProductsBySellTable } from "./components/TopProductsBySellTable"

interface ProductRow {
  id: string
  product: string
  category: string
  couponBased: "Coupon Based" | "One Time"
  salesVolume: string
  orders: number
  piece: number
  status: "Active" | "In Active"
}

export const products: ProductRow[] = [
  {
    id: "1",
    product: "Product A",
    category: "Category AB",
    couponBased: "Coupon Based",
    salesVolume: "QAR 20,00",
    orders: 5,
    piece: 20,
    status: "In Active",
  },
  {
    id: "2",
    product: "Product BC",
    category: "Category AB",
    couponBased: "Coupon Based",
    salesVolume: "QAR 20,00",
    orders: 5,
    piece: 60,
    status: "Active",
  },
  {
    id: "3",
    product: "Product BC",
    category: "Category AB",
    couponBased: "Coupon Based",
    salesVolume: "QAR 20,00",
    orders: 5,
    piece: 20,
    status: "In Active",
  },
  {
    id: "4",
    product: "Product ZBC",
    category: "Category AB",
    couponBased: "One Time",
    salesVolume: "QAR 20,00",
    orders: 5,
    piece: 60,
    status: "Active",
  },
  {
    id: "5",
    product: "Product BC",
    category: "Category AB",
    couponBased: "Coupon Based",
    salesVolume: "QAR 20,00",
    orders: 5,
    piece: 20,
    status: "Active",
  },
  {
    id: "6",
    product: "Product BC",
    category: "Category AB",
    couponBased: "One Time",
    salesVolume: "QAR 20,00",
    orders: 5,
    piece: 20,
    status: "In Active",
  },
  {
    id: "7",
    product: "Product BC",
    category: "Category AB",
    couponBased: "Coupon Based",
    salesVolume: "QAR 20,00",
    orders: 5,
    piece: 20,
    status: "Active",
  },
]


export const TopProductsBySell = () => {
  const { i18n } = useTranslation()

  const validation = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    initialValues: {
      startDate: "",
      endDate: "",
    },
    validationSchema: Yup.object({
      startDate: Yup.date()
        .required(i18n.t("dashboard_startDateValidationMessage") as string)
        .max(
          Yup.ref("endDate"),
          i18n.t("dashboard_maxStartDateValidationMessage") as string
        ),
      endDate: Yup.date()
        .required(i18n.t("dashboard_endDateValidationMessage") as string)
        .min(
          Yup.ref("startDate"),
          i18n.t("dashboard_minEndDateValidationMessage") as string
        ),
    }),
    onSubmit: values => {
      const { startDate, endDate } = values
      console.log(values)

      // TODO: Dispatch
      validation.resetForm()
    },
  })

  const [checkedProducts, setCheckedProducts] = useState<ProductRow[]>([])
  const [isAllChecked, setIsAllChecked] = useState(false)
  const [productsData, setProductsData] = useState<ProductRow[]>(products)

  const toggleAllProducts = () => {
    if (isAllChecked) {
      setCheckedProducts([])
      setIsAllChecked(false)
    } else {
      setCheckedProducts(productsData)
      setIsAllChecked(true)
    }
  }

  const togglecheckedProductHandler = (product: ProductRow) => {
    const isChecked = checkedProducts.some(p => p.id === product.id)
    if (isChecked) {
      setCheckedProducts(checkedProducts.filter(p => p.id !== product.id))
    } else {
      setCheckedProducts([...checkedProducts, product])
    }

    // Update isAllChecked state
    if (checkedProducts.length + 1 === productsData.length) {
      setIsAllChecked(true)
    } else {
      setIsAllChecked(false)
    }
  }

  const toggleActiveProduct = useCallback(
    (product: ProductRow) => {
      setProductsData(prev =>
        prev.map(p =>
          p.id === product.id
            ? {
                ...p,
                status: p.status === "Active" ? "In Active" : "Active",
              }
            : p
        )
      )
    },
    [products]
  )

  const cardsData: {
    title: string
    quantity: number | string
    unitOfMeasure?: string
  }[] = useMemo(() => {
    return [
      {
        title: i18n.t("dashboard_totalSalesProduct"),
        quantity: 200_000,
        unitOfMeasure: i18n.t("dashboard_piece") as string,
      },
      {
        title: i18n.t("dashboard_totalSales"),
        quantity: 200_000,
        unitOfMeasure: i18n.t("common_qar") as string,
      },
      {
        title: i18n.t("dashboard_totalOrder"),
        quantity: 100,
      },
    ]
  }, [i18n])
  return (
    <div className="page-content">
      <div className="container-fluid d-flex flex-column justify-content-between align-items-start">
        <Breadcrumbs
          title={i18n.t("dashboard_dashboard")}
          breadcrumbItem={i18n.t("dashboard_topProducts")}
        />
        <div className="w-100 d-flex flex-column gap-3">
          <h6 className="mb-0 fw-semibold font-size-20 text-capitalize">
            {i18n.t("dashboard_selectPeriod")}
          </h6>
          <Row>
            <Col md="6">
              <FormInput
                label={i18n.t("common_startDate") as string}
                name="startDate"
                type="date"
                validation={validation}
                required
              />
            </Col>
            <Col md="6">
              <FormInput
                label={i18n.t("common_endDate") as string}
                name="endDate"
                type="date"
                validation={validation}
                required
              />
            </Col>
          </Row>

          <Row>
            {cardsData.map((one, key) => (
              <Col
                md="4"
                key={"_col_" + key}
                style={{ height: "fit-content" }}
              >
                <Card className="mini-stats-wid shadow-md rounded-3">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium text-capitalize">
                          {one.title}
                        </p>
                        <div className="d-flex gap-1 align-items-baseline justify-content-start">
                          <h4 className="mb-0">
                            {one.quantity.toLocaleString()} {one.unitOfMeasure}
                          </h4>
                        </div>
                      </div>
                      <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-primary">
                          <i className={"bx bx-tab font-size-24"}></i>
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
          <div className="">
            <TopProductsBySellTable
              products={productsData}
              isAllChecked={isAllChecked}
              checkedProducts={checkedProducts}
              toggleAllProducts={toggleAllProducts}
              togglecheckedProductHandler={togglecheckedProductHandler}
              toggleActiveProduct={toggleActiveProduct}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
